export default __webpack_public_path__ + "assets/models/draco/Octane_ZXR_Orange.glb";